import React from 'react';
import styled from 'styled-components';
import { Row } from 'antd';

import { DocumentResponse } from 'all-in-one-shared-api/dist/apis/documents/DocumentsResponse';

import PdfFileIcon from 'assets/images/documents/pdf-file-icon.svg';

import { IconCard } from 'components';
import FourItemColumn from 'components/fourItemColumn';

const GeneralDocumentRow = styled(Row)`
  margin-top: 40px;
`;

interface GeneralDocumentsProp {
  generalDocuments: DocumentResponse[];
}

function GeneralDocuments({ generalDocuments }: GeneralDocumentsProp) {
  return (
    <GeneralDocumentRow gutter={[{ xs: 8, sm: 16, md: 24 }, 16]} wrap>
      {generalDocuments.map((document) => (
        <FourItemColumn key={document.url}>
          <IconCard
            title={document.name ?? ''}
            description={document.documentDate ?? ''}
            icon={PdfFileIcon}
            to={document.url ?? '#'}
            height="auto"
            isExternal={true}
          />
        </FourItemColumn>
      ))}
    </GeneralDocumentRow>
  );
}

export default GeneralDocuments;
